'use strict';

var $ = require("jquery");

module.exports = exports.default = function () {
    $('#roleEditModalContainer').on('select2:select', 'select[data-edit-modal-id=EditRoleOrganizationId]', function (e) {
        $("[data-edit-modal-id=EditRoleCustomerId]").select2('data', null);
        $("[data-edit-modal-id=EditRoleCustomerId]").prop('disabled', true);

        var organizationId = $('[data-edit-modal-id=EditRoleOrganizationId]').select2('val');
        $('[data-edit-modal-id=EditRoleCustomerId] option').remove();

        $.ajax({
            type: "GET",
            url: '/odata/CustomerByOrganization?id=0' + organizationId,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function success(data) {

                var options = $.map(data.value, function (item) {
                    return { id: item.id, text: item.name + ' (' + item.reference + ')' };
                });

                $('[data-edit-modal-id=EditRoleCustomerId]').select2({
                    data: options,
                    placeholder: "Select customer"
                }).val(null).trigger('change');
                $("[data-edit-modal-id=EditRoleCustomerId]").prop('disabled', false);
            }
        });
    });

    $('#roleEditModalContainer').on('select2:unselect', 'select[data-edit-modal-id=EditRoleOrganizationId]', function (e) {
        $('[data-edit-modal-id=EditRoleCustomerId] option').remove();
        $("[data-edit-modal-id=EditRoleCustomerId]").select2('destroy').val('').select2();
        $("[data-edit-modal-id=EditRoleCustomerId]").prop('disabled', true);
    });

    $('#roleEditModalContainer').on('click', '#edit-role-submit-button', function () {
        $("[data-edit-modal-id=EditRoleCustomerId]").prop('disabled', false);
        var form = $(this).closest("form");
        var url = form.attr('action');

        $.validator.unobtrusive.parse(form);

        if ($(form).valid()) {
            $.ajax({
                type: "POST",
                url: url,
                data: form.serialize(),
                success: function success(data, textStatus, xhr) {
                    if (xhr.status === 200 && data === "") {
                        window.location.reload();
                    } else {
                        $('[data-edit-role-form].modal-body').html(data);
                    }
                }
            });
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/editRole.js
// module id = 431
// module chunks = 0